import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DownloadVersionDialogData {
  maxSubmissionCount: number;
}

interface SubmissionOption {
  value: number;
  label: string;
}

@Component({
  selector: 'app-download-version-dialog',
  templateUrl: './download-version-dialog.component.html',
  styleUrls: ['./download-version-dialog.component.scss'],
  standalone: false,
})
export class DownloadVersionDialogComponent {
  selectedSubmissionCount = 0;
  options: SubmissionOption[] = [];

  constructor(
    private dialogRef: MatDialogRef<DownloadVersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DownloadVersionDialogData
  ) {
    const maxCount = Math.max(0, Number(data?.maxSubmissionCount) || 0);
    this.options = Array.from({ length: maxCount + 1 }, (_, i) => ({
      value: i,
      label: this.getSubmissionLabel(i),
    }));
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(this.selectedSubmissionCount);
  }

  private getSubmissionLabel(submissionCount: number): string {
    const n = submissionCount + 1;
    const suffix = this.getOrdinalSuffix(n);
    return `${n}${suffix} submission`;
  }

  private getOrdinalSuffix(n: number): string {
    const j = n % 10;
    const k = n % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  }
}
